export const getUtms = () => {
  try {
    return JSON.parse(sessionStorage.getItem("utmParams"));
  } catch {
    return null;
  }
};
